module.exports = __webpack_public_path__ + "media/images/MR_lock-076083e5.svg";